import { Grid } from '@chakra-ui/react';
import React from 'react';

import useApiQuery from 'lib/api/useApiQuery';
import { STATS_COUNTER } from 'stubs/stats';
import StatsWidget from 'ui/shared/stats/StatsWidget';

import DataFetchAlert from '../shared/DataFetchAlert';
import { useQuery } from '@tanstack/react-query';

const UNITS_WITHOUT_SPACE = [ 's' ];

const NumberWidgetsList = () => {
  const { data, isPlaceholderData, isError } = useApiQuery('stats_counters', {
    queryOptions: {
      placeholderData: { counters: Array(10).fill(STATS_COUNTER) },
    },
  });
    const burnStats = useQuery<any>({
    queryKey: ["total-burnt"],
    queryFn: async () => {
      const res = await fetch("https://burn.qie.digital/api/burn-stats");

      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      const data = await res.json();
      return data;
    },
  });

  if (isError) {
    return <DataFetchAlert/>;
  }

  return (
    <Grid
      gridTemplateColumns={{ base: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }}
      gridGap={ 4 }
    >
      {
        data?.counters?.map(({ id, title, value, units, description }, index) => {

          let unitsStr = '';
          if (units && UNITS_WITHOUT_SPACE.includes(units)) {
            unitsStr = units;
          } else if (units) {
            unitsStr = ' ' + units;
          }

          return (
            <StatsWidget
              key={ id + (isPlaceholderData ? index : '') }
              label={ title.replaceAll('ETH', 'QIE') }
              value={ `${ Number(value).toLocaleString(undefined, { maximumFractionDigits: 3, notation: 'compact' }) }${ unitsStr.replaceAll('ETH', 'QIE') }` }
              isLoading={ isPlaceholderData }
              hint={ description.replaceAll('ETH', 'QIE') }
            />
          );
        })
      }
      <StatsWidget
        key={"burned_3m"}
        label={"Last 3 Months Burned"}
        value={`${Number(burnStats?.data?.burned_3m||0)} QIE`}
        isLoading={isPlaceholderData}
        hint={'Amount of QIE permanently burned via QIP-1559 base gas fees in the last 3 months.'}
      />
      <StatsWidget
        key={"burned_6m"}
        label={"Last 6 Months Burned"}
        value={`${Number(burnStats?.data?.burned_6m||0)} QIE`}
        isLoading={isPlaceholderData}
        hint={'Amount of QIE permanently burned via QIP-1559 base gas fees in the last 6 months.'}
      />
      <StatsWidget
        key={"burned_24h"}
        label={"Last 24 Hours Burned"}
        value={`${Number(burnStats?.data?.burned_24h||0)} QIE`}
        isLoading={isPlaceholderData}
        hint={'Amount of QIE permanently burned via QIP-1559 base gas fees in the last 24 hours.'}
      />
    </Grid>
  );
};

export default NumberWidgetsList;
